module.exports = __webpack_public_path__ + "static/media/Plusle_gaussian2.65534ee0.png";